/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Coach_Context_TodayInputs */

const en_us2_coach_context_today = /** @type {(inputs: Coach_Context_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout ${i?.label} today`)
};

const pt_br2_coach_context_today = /** @type {(inputs: Coach_Context_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label} hoje`)
};

const es_419_coach_context_today = /** @type {(inputs: Coach_Context_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrenamiento ${i?.label} hoy`)
};

const pt_pt2_coach_context_today = /** @type {(inputs: Coach_Context_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino ${i?.label} hoje`)
};

const fr_fr2_coach_context_today = /** @type {(inputs: Coach_Context_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séance ${i?.label} aujourd'hui`)
};

const de_de2_coach_context_today = /** @type {(inputs: Coach_Context_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Training ${i?.label} heute`)
};

const it_it2_coach_context_today = /** @type {(inputs: Coach_Context_TodayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allenamento ${i?.label} oggi`)
};

/**
* | output |
* | --- |
* | "Workout {label} today" |
*
* @param {Coach_Context_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_context_today = /** @type {((inputs: Coach_Context_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Context_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_context_today(inputs)
	if (locale === "es-419") return es_419_coach_context_today(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_context_today(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_context_today(inputs)
	if (locale === "de-DE") return de_de2_coach_context_today(inputs)
	if (locale === "it-IT") return it_it2_coach_context_today(inputs)
	return en_us2_coach_context_today(inputs)
});
export { coach_context_today as "coach.context_today" }